"use client";

import { useTranslation } from "@/i18n/client";
import type { SecondaryNavLink } from "@/types/nav-bar";
import SecondaryNavItem from "./SecondaryNavItem";
import s from "./SecondaryNavMobile.module.css";

interface SecondaryNavMobileProps {
  dropdownLinks: SecondaryNavLink[];
  links: SecondaryNavLink[];
}

export default function SecondaryNavMobile(props: SecondaryNavMobileProps) {
  const { dropdownLinks, links } = props;
  const { t } = useTranslation("nav");

  return (
    <ul className={s.wrapper}>
      {dropdownLinks.length > 0 && (
        <SecondaryNavItem
          title={t("secondary-nav.dropdown-links.button.label")}
          items={dropdownLinks}
        />
      )}
      {links.length > 0 && (
        <SecondaryNavItem
          title={t("secondary-nav.links.button.label")}
          items={links}
        />
      )}
    </ul>
  );
}
